import type { SessionUser } from '@stockstop/shared';
import { useLogout } from '../../api/queries.js';

/**
 * Wer angemeldet ist, und der Weg hinaus.
 *
 * Der Mandant steht dabei bewusst mit auf dem Schirm und nicht nur die Adresse:
 * Die Daten sind je Konto getrennt, und wer zwei Konten hat, muss auf einen Blick
 * sehen, in welchem er gerade arbeitet — sonst sucht er Positionen, die in einem
 * anderen Mandanten liegen.
 */

export const SessionMenu = ({ user }: { user: SessionUser }): React.JSX.Element => {
  const logout = useLogout();

  /*
   * Ohne Anmeldung gibt es niemanden abzumelden. Statt eines Knopfes, der nichts
   * bewirkt, steht dort der Hinweis, warum — das ist im laufenden Betrieb genau
   * die Frage, die sich stellt, wenn die Anmeldung unerwartet umgangen wird.
   */
  if (user.isDevelopmentSession) {
    return (
      <span className="session session--local" title="AUTH_MODE=disabled in der .env">
        <span className="session__dot" />
        Ohne Anmeldung · Mandant {user.tenantName}
      </span>
    );
  }

  return (
    <span className="session">
      {user.pictureUrl ? (
        <img className="session__avatar" src={user.pictureUrl} alt="" width={22} height={22} />
      ) : null}
      <span className="session__who" title={`${user.email} · Mandant ${user.tenantName}`}>
        {user.name ?? user.email}
      </span>
      <button
        type="button"
        className="session__logout"
        disabled={logout.isPending}
        onClick={() => logout.mutate()}
      >
        {logout.isPending ? 'Meldet ab …' : 'Abmelden'}
      </button>
    </span>
  );
};
